import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { NavigationSecondaryFinancesComponent } from './navigation-secondary-finances.component';
import { NavigationSecondaryModule } from './navigation-secondary.module';

@NgModule({
  imports: [CommonModule, UiModule, NavigationSecondaryModule, TrackingModule],
  declarations: [NavigationSecondaryFinancesComponent],
  exports: [NavigationSecondaryFinancesComponent],
})
export class NavigationSecondaryFinancesModule {}
